import React from 'react';
export function SuccessStories() {
  return <section id="success-stories" className="py-24 bg-white relative" data-id="element-535">
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-transparent to-riskeys-gray-light opacity-30" data-id="element-536"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-537">
        <div className="text-center mb-20" data-id="element-538">
          <h2 className="text-3xl md:text-4xl font-bold text-riskeys-dark mb-5 leading-tight" data-id="element-539">
            Ils nous font{' '}
            <span className="text-riskeys-blue-default" data-id="element-540">confiance</span>
          </h2>
          <div className="w-20 h-1 bg-riskeys-accent-default mx-auto mb-6" data-id="element-541"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-600 leading-relaxed" data-id="element-542">
            Des résultats concrets pour les décideurs les plus exigeants
          </p>
        </div>
        {/* Client logos */}
        <div className="mb-20" data-id="element-543">
          <div className="bg-riskeys-gray-light rounded-lg p-10" data-id="element-544">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center" data-id="element-545">
              <div className="p-4 bg-white rounded-md shadow-sm flex items-center justify-center h-20" data-id="element-546">
                <span className="text-riskeys-blue-default font-semibold" data-id="element-547">
                  Client 1
                </span>
              </div>
              <div className="p-4 bg-white rounded-md shadow-sm flex items-center justify-center h-20" data-id="element-548">
                <span className="text-riskeys-blue-default font-semibold" data-id="element-549">
                  Client 2
                </span>
              </div>
              <div className="p-4 bg-white rounded-md shadow-sm flex items-center justify-center h-20" data-id="element-550">
                <span className="text-riskeys-blue-default font-semibold" data-id="element-551">
                  Client 3
                </span>
              </div>
              <div className="p-4 bg-white rounded-md shadow-sm flex items-center justify-center h-20" data-id="element-552">
                <span className="text-riskeys-blue-default font-semibold" data-id="element-553">
                  Client 4
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-554">
          {/* Case Study 1 */}
          <div className="bg-white rounded-lg shadow-soft overflow-hidden hover:shadow-hover transition-all duration-300 border border-gray-100 group" data-id="element-555">
            <div className="bg-riskeys-blue-dark p-6 relative overflow-hidden" data-id="element-556">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-riskeys-blue-default opacity-30" data-id="element-557"></div>
              <div className="relative z-10" data-id="element-558">
                <div className="text-white/70 text-xs uppercase tracking-wider mb-1 font-medium" data-id="element-559">
                  Secteur
                </div>
                <h3 className="text-white font-bold text-xl mb-1" data-id="element-560">
                  Entreprise industrielle
                </h3>
                <p className="text-white/70 text-sm" data-id="element-561">Secteur manufacturier</p>
              </div>
            </div>
            <div className="p-8" data-id="element-562">
              <div className="flex items-center justify-between mb-6" data-id="element-563">
                <div className="bg-riskeys-accent-light/20 text-riskeys-dark font-semibold px-4 py-1.5 rounded-md text-sm shadow-sm" data-id="element-564">
                  Économie: 27%
                </div>
                <div className="text-gray-500 text-sm font-medium" data-id="element-565">
                  Contrat multirisque
                </div>
              </div>
              <div className="mb-6" data-id="element-566">
                <div className="flex justify-between text-sm mb-1" data-id="element-567">
                  <span className="text-gray-600 font-medium" data-id="element-568">Avant</span>
                  <span className="text-gray-600 font-medium" data-id="element-569">Après</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-570">
                  <div className="bg-riskeys-blue-default h-2.5 rounded-full" style={{
                  width: '73%'
                }} data-id="element-571"></div>
                </div>
                <div className="flex justify-between text-sm mt-1" data-id="element-572">
                  <span className="font-medium text-riskeys-blue-default" data-id="element-573">
                    380K€
                  </span>
                  <span className="font-medium text-riskeys-dark" data-id="element-574">277K€</span>
                </div>
              </div>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-575">
                Renégociation complète du programme d'assurance avec
                amélioration des garanties et réduction significative des primes
                annuelles.
              </p>
              <div className="border-t pt-6 mt-auto" data-id="element-576">
                <p className="text-gray-700 italic" data-id="element-577">
                  "Riskeys a su identifier des économies que nous n'aurions
                  jamais trouvées seuls, tout en améliorant notre couverture."
                </p>
                <p className="text-gray-500 text-sm mt-3 font-medium flex items-center" data-id="element-578">
                  <span className="w-8 h-8 bg-riskeys-blue-light/20 rounded-md flex items-center justify-center mr-2 text-riskeys-blue-default" data-id="element-579">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-580">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" data-id="element-581" />
                    </svg>
                  </span>
                  Directeur Financier
                </p>
              </div>
            </div>
          </div>
          {/* Case Study 2 */}
          <div className="bg-white rounded-lg shadow-soft overflow-hidden hover:shadow-hover transition-all duration-300 border border-gray-100 group" data-id="element-582">
            <div className="bg-riskeys-blue-default p-6 relative overflow-hidden" data-id="element-583">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-riskeys-blue-dark opacity-30" data-id="element-584"></div>
              <div className="relative z-10" data-id="element-585">
                <div className="text-white/70 text-xs uppercase tracking-wider mb-1 font-medium" data-id="element-586">
                  Secteur
                </div>
                <h3 className="text-white font-bold text-xl mb-1" data-id="element-587">
                  Groupe immobilier
                </h3>
                <p className="text-white/70 text-sm" data-id="element-588">Gestion de patrimoine</p>
              </div>
            </div>
            <div className="p-8" data-id="element-589">
              <div className="flex items-center justify-between mb-6" data-id="element-590">
                <div className="bg-riskeys-accent-light/20 text-riskeys-dark font-semibold px-4 py-1.5 rounded-md text-sm shadow-sm" data-id="element-591">
                  Économie: 32%
                </div>
                <div className="text-gray-500 text-sm font-medium" data-id="element-592">
                  Assurance dommages
                </div>
              </div>
              <div className="mb-6" data-id="element-593">
                <div className="flex justify-between text-sm mb-1" data-id="element-594">
                  <span className="text-gray-600 font-medium" data-id="element-595">Avant</span>
                  <span className="text-gray-600 font-medium" data-id="element-596">Après</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-597">
                  <div className="bg-riskeys-blue-default h-2.5 rounded-full" style={{
                  width: '68%'
                }} data-id="element-598"></div>
                </div>
                <div className="flex justify-between text-sm mt-1" data-id="element-599">
                  <span className="font-medium text-riskeys-blue-default" data-id="element-600">
                    625K€
                  </span>
                  <span className="font-medium text-riskeys-dark" data-id="element-601">425K€</span>
                </div>
              </div>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-602">
                Optimisation des contrats d'assurance pour un portefeuille de
                50+ immeubles avec harmonisation des garanties et réduction des
                coûts.
              </p>
              <div className="border-t pt-6 mt-auto" data-id="element-603">
                <p className="text-gray-700 italic" data-id="element-604">
                  "L'expertise de Riskeys nous a permis de réaliser des
                  économies substantielles tout en simplifiant la gestion de nos
                  assurances."
                </p>
                <p className="text-gray-500 text-sm mt-3 font-medium flex items-center" data-id="element-605">
                  <span className="w-8 h-8 bg-riskeys-blue-light/20 rounded-md flex items-center justify-center mr-2 text-riskeys-blue-default" data-id="element-606">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-607">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" data-id="element-608" />
                    </svg>
                  </span>
                  Responsable Patrimoine
                </p>
              </div>
            </div>
          </div>
          {/* Case Study 3 */}
          <div className="bg-white rounded-lg shadow-soft overflow-hidden hover:shadow-hover transition-all duration-300 border border-gray-100 group" data-id="element-609">
            <div className="bg-riskeys-accent-light/50 p-6 relative overflow-hidden" data-id="element-610">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-riskeys-accent-default opacity-30" data-id="element-611"></div>
              <div className="relative z-10" data-id="element-612">
                <div className="text-riskeys-dark/70 text-xs uppercase tracking-wider mb-1 font-medium" data-id="element-613">
                  Secteur
                </div>
                <h3 className="text-riskeys-dark font-bold text-xl mb-1" data-id="element-614">
                  Entreprise de services
                </h3>
                <p className="text-riskeys-dark/70 text-sm" data-id="element-615">
                  Secteur technologique
                </p>
              </div>
            </div>
            <div className="p-8" data-id="element-616">
              <div className="flex items-center justify-between mb-6" data-id="element-617">
                <div className="bg-riskeys-blue-light/20 text-riskeys-blue-default font-semibold px-4 py-1.5 rounded-md text-sm shadow-sm" data-id="element-618">
                  Économie: 21%
                </div>
                <div className="text-gray-500 text-sm font-medium" data-id="element-619">
                  RC Professionnelle
                </div>
              </div>
              <div className="mb-6" data-id="element-620">
                <div className="flex justify-between text-sm mb-1" data-id="element-621">
                  <span className="text-gray-600 font-medium" data-id="element-622">Avant</span>
                  <span className="text-gray-600 font-medium" data-id="element-623">Après</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-624">
                  <div className="bg-riskeys-blue-default h-2.5 rounded-full" style={{
                  width: '79%'
                }} data-id="element-625"></div>
                </div>
                <div className="flex justify-between text-sm mt-1" data-id="element-626">
                  <span className="font-medium text-riskeys-blue-default" data-id="element-627">
                    190K€
                  </span>
                  <span className="font-medium text-riskeys-dark" data-id="element-628">150K€</span>
                </div>
              </div>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-629">
                Restructuration du programme d'assurance RC Pro et Cyber avec
                extension des garanties et optimisation du budget global.
              </p>
              <div className="border-t pt-6 mt-auto" data-id="element-630">
                <p className="text-gray-700 italic" data-id="element-631">
                  "Grâce à Riskeys, nous bénéficions aujourd'hui d'une meilleure
                  protection à un coût réduit. Une collaboration précieuse."
                </p>
                <p className="text-gray-500 text-sm mt-3 font-medium flex items-center" data-id="element-632">
                  <span className="w-8 h-8 bg-riskeys-blue-light/20 rounded-md flex items-center justify-center mr-2 text-riskeys-blue-default" data-id="element-633">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-634">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" data-id="element-635" />
                    </svg>
                  </span>
                  Directeur Général
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-24" data-id="element-636">
          <div className="bg-white rounded-lg shadow-premium p-12 border border-gray-100" data-id="element-637">
            <div className="text-center mb-12" data-id="element-638">
              <h3 className="text-2xl font-bold text-riskeys-dark mb-4" data-id="element-639">
                Notre impact en chiffres
              </h3>
              <p className="text-gray-600" data-id="element-640">
                Des résultats concrets et mesurables pour nos clients
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-641">
              <div className="p-6 bg-riskeys-gray-light rounded-lg hover:bg-riskeys-accent-light/10 transition-colors duration-300" data-id="element-642">
                <div className="text-4xl font-bold text-riskeys-accent-default mb-3" data-id="element-643">
                  +10
                </div>
                <p className="text-riskeys-dark font-medium" data-id="element-644">
                  Années d'expertise
                </p>
              </div>
              <div className="p-6 bg-riskeys-gray-light rounded-lg hover:bg-riskeys-accent-light/30 transition-colors duration-300" data-id="element-645">
                <div className="text-4xl font-bold text-riskeys-accent-dark mb-3" data-id="element-646">
                  25%
                </div>
                <p className="text-riskeys-dark font-medium" data-id="element-647">
                  Économie moyenne
                </p>
              </div>
              <div className="p-6 bg-riskeys-gray-light rounded-lg hover:bg-riskeys-blue-light/10 transition-colors duration-300" data-id="element-648">
                <div className="text-4xl font-bold text-riskeys-dark mb-3" data-id="element-649">
                  200+
                </div>
                <p className="text-riskeys-dark font-medium" data-id="element-650">
                  Clients satisfaits
                </p>
              </div>
              <div className="p-6 bg-riskeys-gray-light rounded-lg hover:bg-riskeys-blue-light/10 transition-colors duration-300" data-id="element-651">
                <div className="text-4xl font-bold text-riskeys-blue-default mb-3" data-id="element-652">
                  100%
                </div>
                <p className="text-riskeys-dark font-medium" data-id="element-653">
                  Paiement au résultat
                </p>
              </div>
            </div>
            <div className="mt-12 pt-12 border-t border-gray-100" data-id="element-654">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-655">
                <div className="mb-8 md:mb-0 md:w-1/2" data-id="element-656">
                  <h4 className="text-xl font-bold text-riskeys-dark mb-4" data-id="element-657">
                    Notre réseau d'experts
                  </h4>
                  <p className="text-gray-600 leading-relaxed" data-id="element-658">
                    Nous collaborons avec un réseau d'experts spécialisés
                    (actuaires, juristes, préventeurs, spécialistes sectoriels)
                    pour vous garantir une analyse complète et objective de vos
                    risques et de vos contrats.
                  </p>
                </div>
                <div className="md:w-1/3" data-id="element-659">
                  <div className="flex flex-wrap justify-center gap-4" data-id="element-660">
                    <div className="px-4 py-2 bg-riskeys-gray-light rounded-md text-riskeys-dark text-sm font-medium" data-id="element-661">
                      Actuaires
                    </div>
                    <div className="px-4 py-2 bg-riskeys-gray-light rounded-md text-riskeys-dark text-sm font-medium" data-id="element-662">
                      Juristes
                    </div>
                    <div className="px-4 py-2 bg-riskeys-gray-light rounded-md text-riskeys-dark text-sm font-medium" data-id="element-663">
                      Préventeurs
                    </div>
                    <div className="px-4 py-2 bg-riskeys-gray-light rounded-md text-riskeys-dark text-sm font-medium" data-id="element-664">
                      Risk managers
                    </div>
                    <div className="px-4 py-2 bg-riskeys-gray-light rounded-md text-riskeys-dark text-sm font-medium" data-id="element-665">
                      Experts sectoriels
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}